<p text-small-regular [ngClass]="[ centerAlign ? 'center' : '' ]" [ngStyle]="{'margin-bottom.px': verticalSpace, 'color': color }">
  <ng-content></ng-content>
</p>
